import useCurrency from '@/Hooks/useCurrency';

/**
 * `Delivery`/`DriverShift`/`DeliveryZone` carry no `currency` column of their
 * own, unlike a `Check` or a `Payment` — so the only correct source for how to
 * render an amount here is the record's own branch, never the tenant default
 * and never the currency of whichever branch happens to be selected in the
 * header. Always the server's decimal string, straight through; never
 * `parseFloat`, never client arithmetic.
 */
export function Money({
  amount,
  branchId,
  className,
}: {
  amount: string | null | undefined;
  branchId: string;
  className?: string;
}) {
  const { format } = useCurrency(branchId);
  return <span className={className ?? 'tabular-nums'}>{format(amount)}</span>;
}

export default Money;
